export const  shapeOptions= [
  { value: "rectangle", label: "t_rectangle", icon: "mdi-rectangle-outline" },
  { value: "circle", label: "t_circle", icon: "mdi-circle-outline" },
  { value: "triangle", label: "t_triangle", icon: "mdi-triangle-outline" },
  { value: "line", label: "t_line", icon: "mdi-minus" },
  { value: "ellipse", label: "t_ellipse", icon: "mdi-ellipse-outline" },
  { value: "arrow", label: "t_arrow", icon: "mdi-arrow-right" },
  { value: "doubleArrow", label: "t_doubleArrow", icon: "mdi-arrow-left-right" }, 
]